import {createContext, useContext} from 'react';

import {ContactOptionsRecipientBlockComponent} from 'lib/api/strapi';

type ContactContextType = {
  preselectedContactReceiver: string | null;
  contactWhomOptionsData: ContactOptionsRecipientBlockComponent[];
};

export const ContactWhomOptionsContext = createContext<ContactContextType>({
  contactWhomOptionsData: [],
  preselectedContactReceiver: null,
});

export const useGetContactWhomOptions = () => useContext(ContactWhomOptionsContext);
